module.exports = __webpack_public_path__ + "c849d67e348bc7d6cb0a4bba9bbbc319.png";